// material
import { useMediaQuery } from "@material-ui/core";
import ReactApexChart from "react-apexcharts";
import "./styles-card.scss";

export default function AppCurrentVisits({ CountBar, loading }) {
	const isSmallScreen = useMediaQuery("(max-width:780px)");

	const chartOptions = {
		series: CountBar.datasets,
		options: {
			chart: {
				type: "bar",
				// height: 200,
				stacked: true,
				toolbar: {
					show: isSmallScreen ? false : true,
				},
				zoom: {
					enabled: true,
				},
			},
			responsive: [
				{
					breakpoint: 480,
					options: {
						legend: {
							position: "bottom",
							offsetX: -10,
							offsetY: 0,
						},
					},
				},
			],
			// title: {
			// 	text: `Perbandingan Ticket Berdasarkan Layanan & Prioritas`,
			// 	align: "left",
			// 	style: {
			// 		fontSize: "16px",
			// 		color: "#666",
			// 	},
			// },
			color: {},
			tooltip: {
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					const paragraph = [];

					const Total = `${
						w.globals.initialSeries[0].data[dataPointIndex] +
						w.globals.initialSeries[1].data[dataPointIndex] +
						w.globals.initialSeries[2].data[dataPointIndex] +
						w.globals.initialSeries[3].data[dataPointIndex]
					}`;
					const labelsPoint = w.globals.labels[dataPointIndex];
					// const data =
					// 	w.globals.initialSeries[seriesIndex].data[dataPointIndex];
					CountBar.datasets.forEach((r) => {
						paragraph.push(
							`<p class="textP">${r.name} : ${r.data[dataPointIndex]}</p>`
						);
					});
					return `
						<div class="bubble bubble--arrow bubble--arrow-s">
							<h4>${labelsPoint}</h4>
							<p class="textH">Total ${Total}</p>
							<hr />
							${paragraph.join(" ")}
						</div>
					`;
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					borderRadius: 10,
				},
			},
			xaxis: {
				categories: CountBar.labels,
			},

			legend: {
				position: "bottom",
				// offsetX: 0,
				// offsetY: 0,
				markers: {
					width: 12,
					height: 12,
					fillColors: ["#f50f02", "#f1f50a", "#00ff40", "#0051ff"],
					radius: 12,
				},
			},
			fill: {
				opacity: 1,
				colors: ["#f50f02", "#f1f50a", "#00ff40", "#0051ff"],
			},
		},
	};

	return (
		<div
			style={{
				backgroundColor: "white",
				boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
				borderRadius: "10px",
				padding: "20px",
			}}
		>
			<h3 style={{ color: "gray" }}>Ticket Berdasarkan Layanan & Prioritas</h3>
			{!loading && (
				<ReactApexChart
					type="bar"
					series={chartOptions.series}
					options={chartOptions.options}
					height={536}
				/>
			)}
		</div>
	);
}
